import * as React from "react";
import styled, { css } from "styled-components";
import * as H from "history";

import Grid from "src/library/components/Hedron";
import { BrandSplitView } from "src/library/components/BrandSplitView";
import { ButtonLink } from "src/library/components/Link";
import { LoadingSpinner } from "src/library/components/LoadingSpinner";
import { Text } from "src/library/components/Text";
import { Logo } from "src/core/shared/components/Logo";
import { useAuth } from "src/core/shared/api/auth";
import { PageProps } from "src/pages/Router/routes";

/**
 * 404 Not Found View
 *
 * @param {*} { history }
 * @returns
 */
const LogoutPage: React.ReactFCWithChildren<PageProps<unknown>> = props => {
  const [ { logout }, { loggingOut, loggedOut } ] = useAuth(false, props.history as H.History<{from?: string}>);

  React.useEffect(() => {
    logout();
  }, []);

  return (
    <BrandSplitView>
      <LogoutInner>
        <Grid.Box className="logo-wrapper">
          <Logo type="dark" />
        </Grid.Box>

        {loggingOut && (
          <>
            <PaddedContainer>
              <LoadingSpinner
                type="circular"
                position="inline"
              />
            </PaddedContainer>

            <PaddedContainer>
              <Text
                color="secondary"
                fontSize="p"
              >
                Logging out....
              </Text>
            </PaddedContainer>
          </>
        )}

        {loggedOut && (
          <>
            <PaddedContainer>
              <Text
                color="secondary"
                fontSize="p"
              >
                You have been successfully logged out.
              </Text>
            </PaddedContainer>

            <PaddedContainer>
              <ButtonLink
                color="white"
                to="/"
              >
                Login
              </ButtonLink>
            </PaddedContainer>
          </>
        )}
      </LogoutInner>
    </BrandSplitView>
  );
};

const PaddedContainer = styled(Grid.Box)`
  ${({ theme }) =>
    css`
      padding-top: ${theme.spacing.padding.xl};
    `};
`;

const LogoutInner = styled(Grid.Bounds)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  ${({ theme }) =>
    css`
      padding: ${theme.spacing.padding.xl};
      padding-bottom: ${theme.spacing.padding.md};
  `};

  .logo-wrapper {
    max-width: 400px;
  }
`;

export default LogoutPage;
